import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { SettingsState } from 'src/app/store/settings/settings.state';
import { SessionState } from 'src/app/store/session/session.state';
import { SamwinLinesStateSelector } from 'src/app/store/samwin/samwin-lines/samwin-lines.selector';
import { ChatsSelectors } from 'src/app/store/samwin/chats/chats.selectors';

@Injectable({
   providedIn: 'root',
})
export class TabClosingPreventionService {
   constructor(private samStore: Store) {}

   init(): void {
      console.trace('initializing tab closing prevention service');
      window.addEventListener('beforeunload', (event) => this.handleBeforeUnloadEvent(event));
   }

   private handleBeforeUnloadEvent(event: BeforeUnloadEvent): void {
      // allow closing as long as the user is not authenticated
      if (!this.samStore.selectSnapshot(SessionState.getIsAuthenticated)) {
         console.trace('Closing tab initiated, prevention currently not active as no user is logged on');
         return;
      }

      // prevent erroneously disconnecting calls by closing tab if there is a call in progress
      if (this.samStore.selectSnapshot(SamwinLinesStateSelector.isCallInProgress)) {
         console.trace('Closing tab initiated, preventing due to active call');
         this.preventClosingTab(event);
         return;
      }

      // prevent erroneously disconnecting chats by closing tab if there is active chat
      if (this.samStore.selectSnapshot(ChatsSelectors.isAnyActiveChats)) {
         console.trace('Closing tab initiated, preventing due to active chats');
         this.preventClosingTab(event);
         return;
      }

      // allow closing without warning when configuration is set to do so
      if (this.samStore.selectSnapshot(SettingsState.getWarnBeforeClosingTab)) {
         console.trace('Closing tab initiated, prevention is disabled');
         this.preventClosingTab(event);
         return;
      }
   }

   private preventClosingTab(event: BeforeUnloadEvent): void {
      console.trace('Closing tab initiated, ask before continuing');
      // see https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
      event.preventDefault();
      event.returnValue = '-';
   }
}
